"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLessThanInRange = void 0;
var inRange = function (a, b, range) {
    var r = range < 0 ? 0 : range;
    return Math.abs(a - b) <= r;
};
var isLessThanInRange = function (a, b, range) {
    return a < b && !inRange(a, b, range);
};
exports.isLessThanInRange = isLessThanInRange;
//# sourceMappingURL=comparison.js.map